module.exports = __webpack_public_path__ + "img/62.ea16a700.jpg";